/* eslint-disable camelcase */
import { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  Segment,
  Header,
  Button,
  Divider,
  Input,
  Image,
  Form,
} from "common-components";
import styled from "styled-components";

import {
  authenticate,
  loginFormComplete,
} from "../../Common/helpers/authentication";

import {
  getMetaContent,
  indiscriminatelyCombineFlashMessages,
} from "../../Common/helpers/meta";
import FormError from "./FormError";

export const TextInput = styled(Input)`
  margin: 1.15em 0;
`;

export const HeaderText = styled(Header)`
  &&& {
    margin-bottom: 1.75em;
    font-size: 20px;
    font-weight: 600;
    white-space: nowrap;
  }
`;

const LinkedInButtonContent = styled(Button.Content)`
  display: inline;
  vertical-align: sub;
  margin-left: 1em;
`;

class Login extends Component {
  state = {
    email: "",
    password: "",
    remember_me: false,
    error: "",
    oauthError: "",
    showError: false,
    loading: false,
  };

  beginAuthentication = (loadingKey) =>
    this.setState({
      [loadingKey]: true,
      error: "",
      oauthError: "",
    });

  handleLogin = async (event, userCredentials) => {
    event.preventDefault();
    this.beginAuthentication("loading");

    const { email, password } = userCredentials;
    const callbacks = {};

    callbacks.resolve = ({ user_return_to, user_root_path }) =>
      window.location.replace(user_return_to || user_root_path);

    callbacks.reject = ({ responseText }) =>
      this.setState({
        loading: false,
        showError: true,
        error: JSON.parse(responseText).error,
      });

    const data = {
      user: { email, password, remember_me: +this.state.remember_me },
    };

    await authenticate("/users/sign_in", data, callbacks, this.props.session);
  };

  displayError = () => {
    const { error, showError } = this.state;
    return error.length > 0 && showError;
  };

  render() {
    let flash;
    const { session } = this.props;
    const { error, loading } = this.state;

    if (session) {
      flash = session.flash;
    }

    let oauthError = "";

    if (flash && flash.flashes && Object.keys(flash.flashes).length > 0) {
      oauthError = indiscriminatelyCombineFlashMessages(flash.flashes);
    }

    const makingRequest = loading;

    const googleAuthUrlFragment = `/users/auth/google_oauth2`;

    return (
      <Segment className="login">
        <HeaderText textAlign="center" as="h2">
          Welcome to HireArt.
        </HeaderText>

        <FormError error={error || oauthError} />

        <form action={googleAuthUrlFragment} method="post">
          <input
            type="hidden"
            name="authenticity_token"
            value={getMetaContent("csrf-token")}
          />
          <Button
            className="google-login-button"
            fluid
            basic
            disabled={makingRequest}
            type="submit"
          >
            <Image className="linkedin" inline src="/assets/google-icon.svg" />
            <LinkedInButtonContent>Sign in with Google</LinkedInButtonContent>
          </Button>
        </form>

        {document.cookie.indexOf("hide_plaintext_auth") > -1 && (
          <div id="hireart-admin-plaintext-auth-explainer">
            HireArt Admins may only login via Google
          </div>
        )}
        {document.cookie.indexOf("hide_plaintext_auth") === -1 && (
          <div>
            <Divider className="horizontal">or</Divider>

            <Form onSubmit={(e) => this.handleLogin(e, this.state)}>
              <Form.Input
                control={TextInput}
                value={this.state.email}
                onChange={(e, { value }) =>
                  this.setState({ email: value, showError: false })
                }
                name="email"
                type="email"
                placeholder="Email"
                fluid
                error={this.displayError()}
                autoFocus
                readOnly={makingRequest}
              />

              <Form.Input
                control={TextInput}
                value={this.state.password}
                onChange={(e, { value }) =>
                  this.setState({ password: value, showError: false })
                }
                name="password"
                type="password"
                placeholder="Password"
                error={this.displayError()}
                fluid
                readOnly={makingRequest}
              />

              <Form.Checkbox
                label="Remember me"
                value={+this.state.remember_me}
                onChange={() =>
                  this.setState(({ remember_me }) => ({
                    remember_me: !remember_me,
                  }))
                }
                readOnly={makingRequest}
              />

              <Button
                loading={loading}
                type="submit"
                fluid
                color="blue"
                disabled={
                  !loginFormComplete(this.state.email, this.state.password) ||
                  makingRequest
                }
              >
                Sign in
              </Button>
            </Form>
            <p className="forgot-password">
              <Link to="/forgot_password">Forgot your password?</Link>
            </p>
          </div>
        )}
      </Segment>
    );
  }
}

const mapDispatchToProps = ({ session }) => ({ session });

export default connect(mapDispatchToProps)(Login);
